<template>
  <v-container>
    <!-- SNACKBAR DE MODIFICACION DE ORDENES -->
    <v-snackbar :color="colorsnackbarAlert" v-model="snackbarAlert" :timeout="timeout" top>
      <v-icon>mdi-message</v-icon>
      {{ SnackbarTextAlert }}

      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbarAlert = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <v-row>

      <v-col cols="12" sm="4" md="">
        <AutocompleteComp textLabel="Nivel" v-model="filtroTemas.id_nivel" :items="nivelDoc" item-value="id_nivel"
          item-text="desc_nivel" @change="seleccionarNivel" />
      </v-col>

      <v-col cols="12" sm="4" md="">
        <AutocompleteComp textLabel="Grado" v-model="filtroTemas.id_grado" :items="gradoDocFilter"
          :isDisable="inhabilitarGradoDoc" item-value="id_grado" item-text="desc_grado" @change="seleccionarGrado" />
      </v-col>

      <v-col cols="12" sm="4" md="">
        <AutocompleteComp textLabel="Área" v-model="filtroTemas.id_area" :items="areaDocFilter"
          :isDisable="inhabilitarAreaDoc" item-value="id_area" item-text="desc_area" @change="seleccionarArea" />
      </v-col>

      <v-col cols="12" sm="4" md="">
        <AutocompleteComp textLabel="Curso" v-model="filtroTemas.id_curso" :items="cursoDocFilter"
          :isDisable="inhabilitarCursoDoc" item-value="id_curso" item-text="desc_curso" @change="seleccionarCurso" />
      </v-col>


      <v-col v-if="botonArea" cols="12" class="d-flex justify-center py-0">
        <v-alert  dense outlined color="primary">
          <v-btn @click="openDialogSimulador('byArea', null)" small color="primary" plain><v-icon left> fas fa-tasks
            </v-icon> PROGRAMAR EXAMEN POR ÁREA
          </v-btn>
        </v-alert>
      </v-col>

      <v-col v-if="botonCurso" cols="12" class="d-flex justify-center py-0">
        <v-alert dense outlined color="primary">
          <v-btn @click="openDialogSimulador('byCurso', null)" small color="primary" plain><v-icon left> fas fa-tasks
            </v-icon> PROGRAMAR EXAMEN POR CURSO
          </v-btn>
        </v-alert>
      </v-col>

      <v-col cols="12">
        <v-sheet color="transparent" class="" v-if="readyload">
          <v-skeleton-loader class="skeleton-simulador mx-auto" type="table-thead, table-row-divider@3, table-tfoot"></v-skeleton-loader>
        </v-sheet>

        <ComundataTablecomp v-else whitSearch :headers="headersUnidad" :search="searchTemasClases"
          :items="itemsTemasClases" :no-data-text="'No hay datos disponibles, seleccionar Área y Curso'"
          groupBy="nombre_tema">



          <template v-slot:autor="{ item }">
            <v-chip small dark class="font-weight-black" :class="item.tipo_contenido == 1 ? 'btn_virtual' : 'grey'">
              {{ item.tipo_contenido == 1 ? '🤵Inteligenio' : '🧑‍🎓Colegio' }}
            </v-chip>
          </template>

          <template v-slot:accion_preguntar="{ item }">
            <ButtonComp color="red" @click="openDialogSimulador('byOne', item)"
              :disabled="filtroTemas.id_grado === undefined ? true : false" textButton="Crear simulación"
              iconBut="far fa-question-circle" tooltipText="Crear simulador de examen" />

          </template>

          <template v-slot:accion_ver="{ item }">
            <ButtonComp :loading="loadingBanco[item.id_clase]" :disabled="loadingBanco[item.id_clase]"
              @click="verBancoPreguntas(item.id_clase, item.tipo_contenido)" verButton
              tooltipText="Ver banco de preguntas" />

          </template>
        </ComundataTablecomp>

      </v-col>
    </v-row>

    <ComunDialogComp maxWidth="600" v-model="dialogCreaSimuladorMasivo"
      :title="'Programar examen ' + tituloSimuladorMasivo" @close-modal="dialogCreaSimuladorMasivo = false">
      <template v-slot:body>
        <v-row>
          <v-col cols="12">
            <span style="font-size: 16px"><strong>Contenidos:</strong>
            </span>
            <v-radio-group v-if="show_tipo_contenido" v-model="tipo_contenido" @change="changeTipoContenido($event)" row
              class="mt-0">
              <v-radio :label="`Inteligenio`" :value="1"></v-radio>
              <v-radio :label="`Colegio`" :value="0"></v-radio>
            </v-radio-group>

            <span>
              {{ tipo_contenido == 1 ? 'Inteligenio' : 'Colegio' }}
            </span>

          </v-col>
          <v-col class="" cols="">
            <v-select dense label="Seleccionar sección" v-model="obtenerSeccion"
              @change="selectorSecciones(obtenerSeccion)" :items="filtroSeccion" item-text="nombre_seccion"
              item-value="idseccion" return-object></v-select>
          </v-col>
          <v-col cols="12">
            <v-subheader v-if="itemAlumnos.length == 0" class="d-flex justify-center">
              <i>
                --- Seleccione la sección para que se muestre la información ---
              </i></v-subheader>
            <v-list v-else>
              <div class="v-text-field__details pt-6">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">Selecciona todos: </div>
                  </div>
                </div>
              </div>
              <v-list-item>
                <v-list-item-action>
                  <v-checkbox class="pl-4" color="yellow darken-3" :indeterminate="algunosAlumnosSeleccionados"
                    :input-value="todosAlumnosSeleccionados" @change="toggleTodosSeleccionados" />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title><b>Mis estudiantes:</b> </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item-group v-model="alumnoCheck" multiple>
                <!-- LOOP DE ALUMNOS USUARIOS -->
                <v-list-item dense v-for="(alumno) in itemAlumnos" :key="alumno.id_usuario" :value="alumno.id_usuario"
                  active-class="yellow lighten-5">
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox class="pl-4" :input-value="active" :true-value="alumno.id_usuario"></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{
                        alumno.nombre_apellido_alumno
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>

      </template>
      <template v-slot:actions>
        <v-spacer class="py-8" />
        <ButtonComp @click="simularExamen(arrayClasesAreas, tipo_contenido)" :loading="loadingMasivo"
          :disabled="tipo_contenido == null ? true : false" textButton="Finalizar programación"
          iconBut="mdi-comment-question-outline" normalButton />
        <v-spacer class="py-8" />
      </template>
    </ComunDialogComp>


    <!------------------------------------->
    <!-- DRAWER EXTRA BANCO DE PREGUNTAS -->
    <!------------------------------------->
    <v-navigation-drawer width="450" app v-model="verPreguntaDrawer" fixed temporary right>
      <v-toolbar dark color="primary">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6 py-2">
              <v-icon class="animate__animated animate__heartBeat animate__infinite" right>
                mdi-comment-question-outline</v-icon>

              Banco de preguntas {{ tipo_contenido == 1 ? ' Inteligenio' : ' Colegio' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-spacer></v-spacer>
        <v-btn fab dark x-small class="btn_style3" @click="verPreguntaDrawer = false">
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-list rounded v-if="arrayPreguntasClase.length == 0">
        <v-alert :class="classAlertanimate" dense outlined type="error">
          Aun no existen <strong>preguntas</strong> para esta
          <strong>clase </strong>
        </v-alert>
      </v-list>
      <v-list v-else dense nav>
        <ol>
          <v-list-item v-for="item in arrayPreguntasClase" :key="item.idpregunta" link>
            <li v-html="item.titulo"></li>
          </v-list-item>
        </ol>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios from "@/helpers/axios";
import AutocompleteComp from '../../../components/ComponentsEst/AutocompleteComp.vue';
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';

export default {
  name: "simuladorEstudianteInicial",
  components: {
    AutocompleteComp,
    ComundataTablecomp,
    ButtonComp,
    ComunDialogComp
    // chipSimulador: () => import("../components/Co-chipSimulador.vue"),
  },
  data: () => ({
    // PROPIEDAD  DEL COMPONENTE CHIP
    chipArray: [
      {
        color: "red accent-4",
        label: true,
        dark: true,
        dataText: "Selecciona información",
        icon: "mdi-arrow-down",
      },
    ],
    //  PROPIEDAD DEL COMPONENTE VSELECT
    searchTemasClases: null,
    datoLogin: sessionStorage,
    paramsClases: {
      id_pais: "",
      id_nivel: "",
      id_grado: "",
      id_area: "",
      id_curso: "",
      id_tema: "",
    },
    itemsTemasClases: [],
    // LOGICA DE SKELETON
    readyload: false,
    // LOGICA DE TEMAS Y CLASES Y POBLACION DE DATOS
    headersUnidad: [
      { text: "GRADO", value: "desc_grado", class: 'header_datatable', align: 'center', },
      { text: "UNIDAD", value: "nombre_tema", class: 'header_datatable', align: 'center', },
      { text: "TEMA", value: "nombre_clase", class: 'header_datatable', align: 'center', },
      { text: "AUTOR", value: "autor", class: 'header_datatable', align: 'center', },
      { text: "CREAR SIMULADOR", value: "accion_preguntar", sortable: false, class: 'header_datatable', align: 'center', },
      {
        text: "VER BANCO DE PREGUNTAS",
        value: "accion_ver",
        sortable: false,
        class: 'header_datatable',
        align: 'center',
      },
    ],
    loadingBanco: [],
    loadingMasivo: false,
    // CLASS ANIMATE
    classAnimate: "",
    classAlertanimate: "",

    // SIDEBAR DE BANCO DE PREGUNTAS
    verPreguntaDrawer: false,

    // LISTAR PREGUNTAS POR CLASE
    arrayPreguntasClase: [],

    // PROPIEDADES PARA ALERTA
    colorsnackbarAlert: "green",
    snackbarAlert: false,
    timeout: 2000,
    SnackbarTextAlert: "",

    dialogCreaSimuladorMasivo: false,
    itemAlumnosSelected: [],

    usedCodes: [],

    //  PROPIEDADES DEL DOCENTE
    progOriginal: [],
    filtroTemas: [],
    nivelDoc: [],
    gradoDocFilter: [],
    areaDocFilter: [],
    cursoDocFilter: [],

    // LOGICA DOCENTE EXCLUSIVO
    alumnoCheck: [],
    disabledAlumno: [],
    selectionarTodosAlumnos: null,
    arrayClasesAreas: [],

    itemAlumnos: [],
    obtenerSeccion: { nombre_seccion: "Selecciona" },
    filtroSeccion: [],
    tituloSimuladorMasivo: "null",

    // variable iniciales
    inhabilitarGradoDoc: true,
    inhabilitarAreaDoc: true,
    inhabilitarCursoDoc: true,

    botonArea: false,
    ValorbotonArea: null,
    botonCurso: false,
    ValorbotonCurso: null,
    tipo_contenido: null,
    show_tipo_contenido: true,
    progOriginalClases: []
  }),
  mounted() { },
  watch: {
    alumnoCheck(alumnos) {
      if (alumnos) {
        for (let u = 0; u < alumnos.length; u++) {
          let alumno = alumnos[u];
          if (alumno == null || alumno == "") {
            this.alumnoCheck.splice(this.alumnoCheck.indexOf(u), 1);
            this.snackbarAlert = true;
            this.colorsnackbarAlert = "red";
            this.SnackbarTextAlert = "Este alumno no tiene usuario";
          }
        }
      }
      this.itemAlumnosSelected = alumnos
    },
    dialogCreaSimuladorMasivo(valor) {
      if (!valor) {
        this.tipo_contenido = null
      }
    }
  },
  computed: {
    alumnosSeleccionados() {
      return this.alumnoCheck.length === 0;
    },
    algunosAlumnosSeleccionados() {
      return this.alumnoCheck.length > 0 && !this.todosAlumnosSeleccionados;
    },
    todosAlumnosSeleccionados() {
      return this.alumnoCheck.length === this.itemAlumnos.length;
    }
  },
  created() {
    this.init();
  },
  methods: {
    toggleTodosSeleccionados() {
      if (this.alumnosSeleccionados || this.algunosAlumnosSeleccionados) {
        this.alumnoCheck = this.itemAlumnos.map(alumno => alumno.id_usuario);
      } else {
        this.alumnoCheck = [];
      }
    },

    toggleGrouping() {
      this.groupedBy = !this.groupedBy; // Invertir el estado
    },
    /** 
     ___________________
    |  FUNCION INICIO */
    async init() {
      const me = this;
      await me.cargaInicialDocente();
    },
    /** 
     __________________________________
    |  METODO RESET SELECTS Y LISTAR */
    async resetSelects() {
      const me = this;
      (me.cursoDocFilter = []),
        (me.areaDocFilter = []),
        (me.gradoDocFilter = []),
        (me.nivelDoc = []),
        await me.cargaInicialDocente();
    },
    /** 
     _____________________________________
    |  METODO OBTENER DATOS DEL DOCENTE */
    async cargaInicialDocente() {
      const me = this;

      NProgress.configure({
        minimum: 0.1,
        trickleSpeed: 50,
        showSpinner: false,
      });

      NProgress.start();

      me.$store.commit("mostrarLoading", {
        titulo: "Cargando Temas ...",
        color: "#fff",
        colorDialog: "#212121",
        ancho: 300,
      });

      me.readyload = true;

      try {
        let params = `/periodo/${me.datoLogin.id_ano_lectivo}/colegio/${me.datoLogin.id_colegio}/usuario/${me.datoLogin.id}`;
        let response = await axios.get(
          `/academico/progDocente/getQuery${params}`
        );
        let data = response.data;

        me.nivelDoc = data.payload.NivelDoc;
        me.gradoDoc = data.payload.GradoDoc;
        me.areaDoc = data.payload.AreaDoc;
        me.cursoDoc = data.payload.CursoDoc;
        me.seccionDoc = data.payload.SeccionDoc;
        me.itemsTemasClases = Object.values(
          data.payload.ProgDocente.reduce((acc, obj) => {
            acc[obj.id_clase] = obj;
            return acc;
          }, {})
        );

        me.progOriginal = Object.values(
          data.payload.ProgDocente.reduce((acc, obj) => {
            acc[obj.id_clase] = obj;
            return acc;
          }, {})
        );
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      } finally {

        setTimeout(async () => {
          me.readyload = false;
          NProgress.done();
          me.$store.commit("ocultarLoading");
        }, 500);
      }
    },
    /** 
     ______________________________
    |  METODO SELECCIONAR NIVEL  */
    seleccionarNivel() {
      this.inhabilitarGradoDoc = false;
      this.inhabilitarAreaDoc = true;
      this.inhabilitarCursoDoc = true;

      // filtro y cargo los valores del grado segun el nivel
      //let filtro = this.asociarCl.id_nivel

      this.gradoDocFilter = this.gradoDoc.filter(
        (el) => el.id_nivel == this.filtroTemas.id_nivel
      );

      //CARGAMOS LA PROGRAMACION EN BASE AL NIVEL
      this.itemsTemasClases = this.progOriginal.filter(
        (el) => el.id_nivel == this.filtroTemas.id_nivel
      );
    },
    /** 
     ______________________________
    |  METODO SELECCIONAR GRADO  */
    seleccionarGrado() {
      this.inhabilitarAreaDoc = false;
      this.inhabilitarCursoDoc = true;
      this.areaDocFilter = this.areaDoc.filter(
        (el) => el.id_grado == this.filtroTemas.id_grado
      );

      this.seccionDocFilter = this.seccionDoc.filter(
        (el) => el.id_grado == this.filtroTemas.id_grado
      );

      this.itemsTemasClases = this.progOriginal.filter(
        (el) =>
          el.id_nivel == this.filtroTemas.id_nivel &&
          el.id_grado == this.filtroTemas.id_grado
      );
    },
    /** 
     _____________________________
    |  METODO SELECCIONAR AREA  */
    seleccionarArea() {
      const me = this;

      me.inhabilitarCursoDoc = false;
      //me.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      let gradoDocFilter = me.cursoDoc.filter(
        (el) => el.id_grado == me.filtroTemas.id_grado
      );
      me.cursoDocFilter = gradoDocFilter.filter(
        (el) => el.id_area == me.filtroTemas.id_area
      );

      me.itemsTemasClases = me.progOriginal.filter(
        (el) =>
          el.id_nivel == me.filtroTemas.id_nivel &&
          el.id_grado == me.filtroTemas.id_grado &&
          el.id_area == me.filtroTemas.id_area
      );

      me.botonArea = true;
      me.ValorbotonArea = this.filtroTemas.id_area;
      me.botonCurso = false;
      me.ValorbotonCurso = null;
    },
    /** 
     ______________________________
    |  METODO SELECCIONAR CURSO  */
    seleccionarCurso() {
      const me = this;

      me.itemsTemasClases = me.progOriginal.filter(
        (el) =>
          el.id_nivel == me.filtroTemas.id_nivel &&
          el.id_grado == me.filtroTemas.id_grado &&
          el.id_area == me.filtroTemas.id_area &&
          el.id_curso == me.filtroTemas.id_curso
      );

      me.botonCurso = true;
      me.ValorbotonCurso = this.filtroTemas.id_curso;
      me.botonArea = false;
      me.ValorbotonArea = null;
    },
    /** 
     _________________________
    |  SELECTOR SERCCIONES  */
    async selectorSecciones(itemSecciones) {
      const me = this;

      me.itemAlumnosSelected = [];
      me.alumnoCheck = [];
      await me.cargaAlumnosUser(itemSecciones.id_seccion);
    },
    /** 
     ____________________________
    |  METODO OBTENER SECCION  */
    async listarSeccion(id_nivel, id_grado) {
      const me = this;

      me.obtenerSeccion = { nombre_seccion: "Selecciona" };
      me.itemAlumnos = [];
      me.filtroSeccion = [];

      try {
        const response = await axios.get(
          `/simulador/simuladorExamen/simuladorExamenes/simuladorE/listarSeccion/${me.datoLogin.id_colegio}/ano/${me.datoLogin.id_ano_lectivo}/nivel/${id_nivel}/grado/${id_grado}`
        );

        me.filtroSeccion = response.data;

      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /** 
    ___________________________________
   |  METODO CARGAR ALUMNOS USUARIO  */
    async cargaAlumnosUser(id_seccion) {
      const me = this;
      me.itemAlumnos = [];
      try {
        const params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/seccion/${id_seccion}`;

        const response = await axios.get(
          `/academico/asistencia/getAlumnoUser${params}`
        );
        me.itemAlumnos = response.data.AlumnoUsuario[0];
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /** 
     ____________________________________________________
    |  METODO FILTRA LAS CLASES POR TIPO DE CONTENIDO  */
    changeTipoContenido(tipo_contenido) {
      const me = this;
      me.arrayClasesAreas = []

      let progOriginalClases = me.itemsTemasClases.filter(
        (clase) =>
          clase.tipo_contenido == tipo_contenido
      );

      progOriginalClases.forEach((clase) => {
        me.arrayClasesAreas.push(clase.id_clase);
      });

    },
    /** 
     __________________________________________________________________
    |  METODO ABRIR MODAL SELECCION DE ALUMNOS PARA CREAR SIMULADOR  */
    openDialogSimulador(string, item) {
      // * Determinar el tipo de contenido
      const me = this;
      me.listarSeccion(me.filtroTemas.id_nivel, me.filtroTemas.id_grado);

      if (item != null) {
        me.show_tipo_contenido = false
      } else {
        me.show_tipo_contenido = true
      }

      me.dialogCreaSimuladorMasivo = true;

      switch (string) {
        case "byArea":

          me.tituloSimuladorMasivo = "por área";
          break;

        case "byCurso":
          me.tituloSimuladorMasivo = "por curso";
          break;

        case "byOne":
          me.arrayClasesAreas = []
          me.tipo_contenido = item.tipo_contenido;
          me.arrayClasesAreas.push(item.id_clase);
          me.tituloSimuladorMasivo = "por clase";
          break;

        default:
          break;
      }
    },
    /** 
     ___________________________________
    |  MÉTODO VER BANCO DE PREGUNTAS  */
    verBancoPreguntas(idclase, tipo_contenido) {
      const me = this;
      me.loadingBanco[idclase] = true;
      me.listarPreguntasPorClases(idclase, tipo_contenido);
    },
    /** 
     _________________________________________________
    |  MÉTODO LISTAR TODAS LAS PREGUNTAS POR CLASE  */
    async listarPreguntasPorClases(idclase, tipo_contenido) {

      const me = this;
      let URI;
      this.tipo_contenido = tipo_contenido
      if (tipo_contenido == 0) {
        URI = "/simulador/simuladorExamenColegio/simuladorAdmPreguntas/simuladorAdmP/listaAdm/"
      } else {
        URI = "/simulador/simuladorExamen/simuladorPreguntas/simuladorP/lista/"
      }

      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();

      try {
        const response = await axios.get(URI + idclase);

        me.arrayPreguntasClase = response.data;

        setTimeout(async () => {
          NProgress.done();
          me.verPreguntaDrawer = true;
          me.loadingBanco[idclase] = false;
          me.classAlertanimate = "animate__animated animate__bounceIn";
        }, 800);
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }

    },
    /** 
     ___________________________________
    |  FUNCION GENERAR CODIGOS RANDOM */
    generateRandomCode(length) {
      // debugger;
      let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let code = "";

      while (code.length < length) {
        let randomChar = characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
        code += randomChar;
      }

      if (this.usedCodes.includes(code)) {
        // If the code is already used, generate a new one recursively
        return this.generateRandomCode(length);
      }

      this.usedCodes.push(code);
      return code;
    },
    /** 
     ___________________________________
    |  FUNCION CREAR EXAMEN ALEATORIO */
    async simularExamen(clases, tipo_contenido) {
      // DEFINE SI CLASE ES ARRAY O SIMPLE STRING NÚMERICO
      let URI;
      this.tipo_contenido = tipo_contenido
      if (tipo_contenido == 0) {
        URI = "/simulador/simuladorExamenColegio/simuladorAdmRespuestas/simuladorAdmR/listaresAdm/"
      } else {
        URI = "/simulador/simuladorExamen/simuladorRespuestas/simuladorR/listares/"
      }

      if (this.itemAlumnosSelected.length == 0) {
        this.snackbarAlert = true;
        this.colorsnackbarAlert = "red";
        this.SnackbarTextAlert = "Se debe seleccionar al menos un estudiante";
        return false;
      }


      if (clases.length == 0 || clases == "") {
        this.snackbarAlert = true;
        this.colorsnackbarAlert = "red";
        this.SnackbarTextAlert = "No existe clase relacionada";
        return false;
      }

      let ClasesArray = [];
      let Usuarios = [];
      this.loadingMasivo = true;
      ClasesArray = clases;
      Usuarios = this.itemAlumnosSelected;

      try {
        const response = await axios.get(URI + ClasesArray);

        if (response.data.length != 0) {
          NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
          NProgress.start();

          let map = new Map();
          response.data.forEach((currentValue) => {
            map.has(currentValue.idpregunta)
              ? map.get(currentValue.idpregunta).push({
                estado: currentValue.estado,
                pregunta: currentValue.pregunta,
                idrespuesta: currentValue.idrespuesta,
                idtema: currentValue.idtema,
                orden: currentValue.orden,
                respuesta: currentValue.respuesta,
                valor_respuesta: currentValue.valor_respuesta,
              })
              : map.set(currentValue.idpregunta, [
                {
                  estado: currentValue.estado,
                  pregunta: currentValue.pregunta,
                  idrespuesta: currentValue.idrespuesta,
                  idtema: currentValue.idtema,
                  orden: currentValue.orden,
                  respuesta: currentValue.respuesta,
                  valor_respuesta: currentValue.valor_respuesta,
                },
              ]);
          });

          const arr = Array.from(map, ([idpregunta, respuestas]) => {
            return { idpregunta, respuestas };
          });

          const PreguntaArrayRandom = [];
          const arrayMapRandom = arr;
          var obj = arrayMapRandom.sort(() => Math.random() - 0.5);
          for (let i = 0; i < 6; i++) {  // AQUI DEFINIMOS EL NUMERO DE PREGUNTAS PARA GENERAR EL ALEATORIO - ESTO PUEDE SER DINAMICO
            PreguntaArrayRandom.push(obj[i]);
          }

          await this.guardarDetalleExamen(PreguntaArrayRandom, clases, Usuarios, tipo_contenido);
        } else {
          setTimeout(async () => {
            this.loadingMasivo = false;
            this.snackbarAlert = true;
            this.colorsnackbarAlert = "red";
            this.SnackbarTextAlert = "No hay preguntas para esta clase";
            this.dialogCreaSimuladorMasivo = false;
            this.itemAlumnosSelected = [];
          }, 500);
        }
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /** 
     __________________________________________
    |  FUNCION GUARDAR EXAMEN DETALLE ALUMNO */
    async guardarDetalleExamen(itemRespuestas, clases, usuarios, tipo_contenido) {
      const me = this;
      let URI;
      if (tipo_contenido == 0) {
        URI = "/simulador/simuladorExamenColegio/simuladorAdmExamenes/simuladorAdmE/registraAdmExamen"
      } else {
        URI = "/simulador/simuladorExamen/simuladorExamenes/simuladorE/registraExamen"
      }
      itemRespuestas.forEach((obj) => {
        obj.idexamen = "";
        obj.valor_pregunta = false;
        obj.respuestas;
      });

      try {
        let fecha = new Date();
        let dia = fecha.getDay();
        let milisegundos = dia + fecha.getMilliseconds();
        let codigoRan = me.generateRandomCode(6);
        await axios.post(
          URI,
          {
            usuarios: usuarios,
            perfil: me.datoLogin.licencia_perfil.toUpperCase(), //VALIDAR QUE SIEMPRE SEA EL DOCENTE QUIEN EJECUTE ESTO
            observacion: "",
            codigo: `EX${milisegundos}-${codigoRan}`,
            calificacion: "",
            estado: true,
            idautor: me.datoLogin.id,
            tipo_muestra: "SIMULADOR",
            clases: clases,
            prioridad: 0,
            id_ano_lectivo: +me.datoLogin.id_ano_lectivo,
            id_colegio: +me.datoLogin.id_colegio,
            respuestas: itemRespuestas,
          }
        );

        setTimeout(async () => {
          NProgress.done();

          this.$router.push("/lista_docente_simuladores");
          me.$store.commit("changedStateTab");
          // me.tab = "tab-2";
          // me.tab2ClassAnimate = "animate__animated animate__heartBeat";
          // me.claseAnimada = "animate__animated animate__bounceIn";

          setTimeout(() => {
            // me.tab2ClassAnimate = "";
            // me.claseAnimada = "";
          }, 700);
        }, 800);
        // me.dialogCreaSimuladorMasivo = false;
        // me.itemAlumnosSelected = [];
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
  },
};
</script>
